<template>
  <div class="sd-search-view">
    <div class="sd-scrollable-div">
      <div class="sd-anchor-top"></div>

      <filters />
      <div class="sd-add-div" v-if="isResults">
        <a v-bind:href="mailAddress">
          Ein neues Ticket erstellen
        </a>
      </div>

      <div class="sd-pagi-wrapper">
        <search-pagination v-if="isResults"
          :routeKey="routeKey"
          :jiraTotal="jiraTotal"
          :confluencePreviousReq="confluencePreviousReq"
          :confluenceNextReq="confluenceNextReq"
          :textSearch="searchValue"
          :maxResults="maxResults"
        />
      </div>

      <div v-if="displayCards">
        <transition :name="transition">
          <div class="sd-results-div" :key="currentPage" v-if="isResults"
            v-bind:class="{ loading: loader }"
          >
            <!-- Card for Confluence text page match -->
            <confluence-card v-if="confluenceResults.length &&
              currentPage <= confluencePageIncrement"
              :confluenceResults="confluenceResults"
              :routeKey="routeKey"
            />
            <!-- Card for Jira issue text match -->
            <jira-card v-if="jiraResults.length &&
              currentPage <= jiraIncrementPage"
              :displayMethod="'text-search-list'"
              :baseUrl="baseUrl"
              :mailAddress="mailAddress"
              :routeKey="routeKey"
              :preloadedResult="false"
              :preloadedComments="false"
              :jiraResults="jiraResults"
            />
          </div>
        </transition>
      </div>

      <transition :name="transition">
        <div v-if="displayList">
          <div class="sd-results-div" :key="currentPage" v-if="jiraResults">
            <list-view v-if="jiraResults.length"
              :loader="loader"
              :results="jiraResults"
            />
          </div>
        </div>
      </transition>

      <loader-animation
        :loader="loader"
        :isResults="isResults"
        :errorMessage="null"
      />

    </div>

    <arrow-top v-if="isResults" />
  </div>
</template>

<script>
import axios from 'axios';
import mixin from './mixins/Mixins';
import ArrowTop from '../components/ArrowTop';
import LoaderAnimation from '../components/LoaderAnimation';

import SearchPagination from './childs/SearchPagination';
import Filters from './childs/Filters';
import JiraCard from './childs/JiraCard';
import ConfluenceCard from './childs/ConfluenceCard';
import ListView from './childs/ListView';

export default {
  name: 'sd-search-view',
  mixins: [mixin],
  components: {
    ArrowTop,
    LoaderAnimation,
    SearchPagination,
    Filters,
    JiraCard,
    ConfluenceCard,
    ListView,
  },

  data() {
    return {
      baseUrl: this.baseUrl,
      mailAddress: this.mailAddress,
      confluencePreviousReq: undefined,
      confluenceNextReq: undefined,
      announcement: this.announcement,
      jiraTotal: 0,
    };
  },

  computed: {
    startAt() {
      return this.$store.state.startAt;
    },
    jiraResults() {
      return this.$store.state.jiraResults;
    },
    confluenceResults() {
      return this.$store.state.confluenceResults;
    },
    currentPage() {
      return this.$store.state.currentPage;
    },
    confluencePageIncrement() {
      return this.$store.state.confluencePageIncrement;
    },
    jiraIncrementPage() {
      return this.$store.state.jiraIncrementPage;
    },
    transition() {
      return this.$store.state.transition;
    },
    loader() {
      return this.$store.state.loader;
    },
    searchValue() {
      return this.$store.state.filters.searchValue;
    },
    displayCards() {
      return this.$store.state.filters.displayCards;
    },
    displayList() {
      return this.$store.state.filters.displayList;
    },
    sortKey() {
      return this.$store.state.filters.sortKey;
    },
    sortOrder() {
      return this.$store.state.filters.sortOrder;
    },
    searchJira() {
      return this.$store.state.filters.searchJira;
    },
    searchConfluence() {
      return this.$store.state.filters.searchConfluence;
    },
    searchPersonal() {
      return this.$store.state.filters.searchPersonal;
    },
    searchStatus() {
      return this.$store.state.filters.searchStatus;
    },
    searchClosed() {
      return this.$store.state.filters.searchClosed;
    },
    searchOpened() {
      return this.$store.state.filters.searchOpened;
    },
    userName() {
      return this.$store.state.user.userName;
    },
    isLogin() {
      return this.$store.state.user.isLogin;
    },
    isResults() {
      if (
        (Array.isArray(this.confluenceResults) &&
        (this.confluenceResults.length)) ||
        (Array.isArray(this.jiraResults) &&
        (this.jiraResults.length))
      ) {
        return true;
      }
      return false;
    },
    maxResults() {
      return this.displayCards ? 5 : 25;
    },
  },

  watch: {
    userName(val) {
      if (val.length > 0) {
        this.$emit('emitSearch');
      }
    },

    announcement(newMessage) {
      if (newMessage.length > 0) {
        const users = JSON.parse(localStorage.getItem('users'));
        const lastMessage = users[this.userName].lastNews[this.routeKey];
        if (lastMessage !== newMessage) {
          // Trigger the announcement opening
          this.showAnnouncementSetter(true);
          // Save the new message in localStorage
          users[this.userName].lastNews[this.routeKey] = newMessage;
          localStorage.setItem('users', JSON.stringify(users));
          // Unset the store isLogin
          this.$store.commit('setIsLogin', false);
        }
      }
    },
  },

  created() {
    this.reinitializeData();
    // Listen to emit of Search event.
    this.$on('emitSearch', () => {
      this.search();
    });
    /**
    * Hold config infos
    */
    this.baseUrl = window.location.origin;
    this.routeKey = this.$route.params.key.toLowerCase();
    this.mailAddress = this.$config[this.routeKey].mailAddress;
  },

  mounted() {
    this.$store.commit('SET_LOADER', true);
    this.$nextTick(() => {
      if (this.isLogin === true) {
        this.queryAnnouncement(this.routeKey);
      }
      if (typeof this.userName !== 'undefined' && this.userName.length > 0) {
        this.$emit('emitSearch');
      }
    });
  },

  methods: {
    reinitializeData() {
      this.confluencePreviousReq = undefined;
      this.confluenceNextReq = undefined;
      this.$store.commit('RESET_STORE');
    },

    getFilteredPromises(searchJira, searchConf) {
      const promises = [];
      if (this.searchJira === true || this.searchPersonal === true) {
        promises.push(this.axiosPromise(searchJira, 'jira'));
      }
      if (this.searchConfluence === true) {
        promises.push(this.axiosPromise(searchConf, 'confluence'));
      }
      return promises;
    },

    search() {
      this.$store.commit('SET_LOADER', true);

      const wordSearch = this.searchValue.length ? this.searchValue : false;
      const searchJira = this.jqlQueryGenerator(
        wordSearch,
        `portal=${this.routeKey}`,
        this.startAt,
        this.maxResults,
        this.searchPersonal,
        this.searchJira,
        this.searchStatus,
        this.searchOpened,
        this.searchClosed,
        this.sortKey,
        this.sortOrder,
      );

      const searchConf = this.cqlQueryGenerator(
        wordSearch,
        `portal=${this.routeKey}`,
        0,
      );
      const promises = this.getFilteredPromises(
        searchJira,
        searchConf,
      );
      Promise.all(promises).then((responses) => {
        this.handleResponses(responses);
        this.$store.commit('SET_LOADER', false);
      }).catch((error) => {
        this.$store.commit('SET_LOADER', false);
        this.logError(error);
      });
    },

    axiosPromise(url, promiseName) {
      return axios.get(url, {
        headers: {
          Pragma: 'no-cache',
          'Cache-Control': 'no-cache',
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        const promise = { response, promise: promiseName };
        return promise;
      });
    },

    resetConfluence() {
      this.$store.commit('SET_CONFLUENCE_RESULTS', []);
      this.confluencePreviousReq = undefined;
      this.confluenceNextReq = undefined;
    },

    resetJira() {
      this.$store.commit('SET_JIRA_RESULTS', []);
      this.jiraTotal = 0;
    },

    resetResults(p) {
      if (p === 'jira') {
        this.resetConfluence();
      } else if (p === 'confluence') {
        this.resetJira();
      } else {
        this.resetJira();
        this.resetConfluence();
      }
    },

    handlePromise(p) {
      if (p.promise === 'jira') {
        this.$store.commit('SET_JIRA_RESULTS', p.response.data.issues);
        this.jiraTotal = p.response.data.total;
      }
      if (p.promise === 'confluence') {
        this.$store.commit('SET_CONFLUENCE_RESULTS', p.response.data.results);
        const portal = `portal=${this.routeKey}`;

        this.confluenceNextReq = p.response.data._links.next ?
          this.cqlQueryGenerator(
            this.searchValue,
            portal,
            p.response.data.start + 5,
          ) : undefined;

        this.confluencePreviousReq = this.cqlQueryGenerator(
          this.searchValue,
          portal,
          0,
        );
      }
    },

    handleResponses(promises) {
      if (promises.length === 1) {
        this.handlePromise(promises[0]);
        // Set to default values
        this.resetResults(promises[0].promise)
      } else if (!promises.length) {
        this.resetResults()
      } else {
        promises.forEach((promise) => {
          this.handlePromise(promise);
        });
      }
    },
  },
};
</script>

<style lang="scss">
@import "./../Globals.scss";

.sd-search-view {
  height: 100vh;
  position: relative;

  .sd-add-div {
    padding-top: 15px;
    max-width: 300px;
    margin: auto;
    position: relative;
    z-index: 99;
    cursor: pointer;

  a {
      cursor: pointer;
      display: block;
      background: white;
      padding: 5px;
      margin: 0 auto;
      font-size: 14px;
      color: $sd-color-blue;
      font-weight: bold;
      box-shadow: 0 1px 1px 0  rgba(0, 0, 0, 0.1);
      border: 1px solid #ddd;

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .sd-pagi-wrapper {
    margin-top: -34px;
    padding-bottom: 20px;

  }

  .sd-results-div {
    transition: all .5s cubic-bezier(.55,0,.1,1);
    margin-bottom: 120px;
  }

  .list-left-enter, .list-right-leave-to {
    opacity: 0;
    transform: translate(30px, 0);
  }

  .list-left-leave-to, .list-right-enter {
    opacity: 0;
    transform: translate(-30px, 0);
  }
}

@media (max-width: 720px) {
  .sd-search-view {
    font-size: 11px;

    .sd-add-div {
      max-width: 170px;
      padding-top: 10px;
      padding-bottom: 0;

      a {
        font-size: 11px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// SearchView.vue?3757ce78